import { Tag } from 'baseui/tag';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  content: string;
  color?: string;
  backgroundColor?: string;
};

function CustomTag({ content, color = '#fff', backgroundColor = 'rgba(0, 0, 0, 0.3)' }: Readonly<Props>) {
  const { theme } = useStyles();
  return (
    <Tag
      color={color}
      kind="custom"
      closeable={false}
      size="small"
      overrides={{
        Root: {
          style: {
            backgroundColor,
            borderTopWidth: '1px',
            borderRightWidth: '1px',
            borderBottomWidth: '1px',
            borderLeftWidth: '1px',
            paddingTop: '0',
            paddingRight: '8px',
            paddingBottom: '0',
            paddingLeft: '8px',
            height: '20px',
            marginTop: 0,
            marginLeft: 0,
            marginBottom: 0,
            marginRight: 0,
            borderTopRightRadius: theme.sizing.scale800,
            borderBottomRightRadius: theme.sizing.scale800,
            borderBottomLeftRadius: theme.sizing.scale800,
            borderTopLeftRadius: theme.sizing.scale800,
            borderTopColor: color,
            borderRightColor: color,
            borderLeftColor: color,
            borderBottomColor: color,
          },
        },
        Text: {
          style: {
            fontSize: '12px',
            color,
          },
        },
      }}
    >
      {content}
    </Tag>
  );
}

export default CustomTag;
